import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { NewProblemForm } from '@/features/AdminProblems/NewProblemForm';

export const Route = createFileRoute('/trainer/problems/new')({
  component: TrainerNewProblemPage,
});

function TrainerNewProblemPage() {
  const navigate = useNavigate();
  return (
    <NewProblemForm
      onBack={() => navigate({ to: '/trainer/problems' })}
      onCreated={id => navigate({ to: '/trainer/problems/$problemId', params: { problemId: id } })}
    />
  );
}
